

import CloudDownload from '@material-ui/icons/CloudDownload';
import { IconButton } from '@material-ui/core';
import { useTranslate, TextInput } from 'react-admin';
import { useState } from 'react';

const DisplayFile = (props) => {
    const translate = useTranslate();
    const { source, resource, value } = props;
    const openDoc = () => {
        window.open(value)
    };
    if (!source || !value) return <div></div>;
    return <IconButton
        color="inherit"
        aria-label={translate(`resources.${resource}.fields.${source}`)}
        onClick={openDoc}
    ><CloudDownload /></IconButton>
};

const ExternalLink = (props) => {
    const { record, source, disabled } = props;
    const [showText, setShowText] = useState(false);
    const [value, setValue] = useState(record[source]);
    return <>
        <DisplayFile {...props} value={value} />
        {disabled === false && <IconButton
            color="inherit"
            onClick={() => {
                setShowText(!showText);
            }}><div className="icon editable"></div></IconButton>}
        {showText && <TextInput source={source} onChange={(event) => {
            setValue(event.target.value);
        }} />}
    </>
};

ExternalLink.defaultProps = {
    addLabel: true
};


export default ExternalLink;